import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '../../config';

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative mt-auto">
            {/* Top gradient line */}
            <div className="h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent" />

            <div className="bg-black/60 backdrop-blur-sm py-8 px-4 sm:px-6 lg:px-8">
                <div className="max-w-[2000px] mx-auto">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        {/* Logo/Brand */}
                        <button
                            onClick={() => navigate('/')}
                            className="group focus:outline-none"
                        >
                            <span className="text-lg sm:text-xl font-bold 
                                bg-gradient-to-r from-amber-400 via-orange-500 to-rose-500 
                                bg-clip-text text-transparent
                                group-hover:drop-shadow-[0_0_20px_rgba(251,191,36,0.5)]
                                transition-all duration-300">
                                {APP_CONFIG.name}
                            </span>
                        </button>

                        {/* Copyright */}
                        <p className="text-gray-500 text-sm">
                            © {currentYear} {APP_CONFIG.name}. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
